/*
 * @Description:
 * @Author: gumingchen
 * @Email: 1240235512@qq.com
 * @Date: 2021-04-02 18:59:43
 * @LastEditors: gumingchen
 * @LastEditTime: 2021-04-18 09:16:20
 */
import { router } from '@/router'

// todo: ITab value 格式：{a}-{b}-{c}-{d}
// todo: a: 路由name b: 菜单ID c: 路由query字符串 d: 路由params字符串
// todo: c、d 支持多开的时候需要
const defaultTabs = [{
    value: 'home-home-{}-{}',
    label_cn: '首页',
    label_en: 'Home',
    name: 'home',
    path: '/home',
    query: {}, // 路由参数
    params: {}, // 路由参数
    closable: false, // true：可以关闭
    menuId: 'home'
}]

export default {
    state: {
        active: '',
        tabs: [],
        activeTab: {}
    },
    getters: {},
    mutations: {
        SET_ACTIVE: (state, active) => {
            state.active = active
        },
        SET_TABS: (state, tabs) => {
            state.tabs = tabs
        },
        ADD_TABS: (state, tab) => {
            state.tabs.push(tab)
        },
        SET_ACTIVE_TAB: (state, tab) => {
            state.activeTab = tab
        }
    },
    actions: {
        /**
         * 设置当前选中
         * @param {*} param0
         * @param {*} active
         * @returns
         */
        setActive({ commit }, active) {
            commit('SET_ACTIVE', active)
        },
        /**
         * 路由变化事件 设置当前选中、添加标签
         * @param {*} param0
         * @param {*} route
         */

        changeHandle({ commit, state }, tab) {
            let tabs = this.tabs
            const key = tab.key
            if (state.tabs.every(item => item.key !== key)) {
                var newtab = {
                    iconCls: tab.iconCls,
                    title: tab.title,
                    component: tab.component,
                    path: tab.path,
                    params: tab.params,
                    name: key,
                    key: key,
                    visible: true
                }
                commit('SET_ACTIVE_TAB', newtab)
                commit('ADD_TABS', newtab)
            }
            commit('SET_ACTIVE', key)
        },
        /**
         * 删除tabs
         * @param {*} param0
         * @param {*} values
         */
        removeHandle({ commit, state }, values) {
            // console.log(values)
            // 过滤出不用删除的标签页
            let tabs = state.tabs.filter(item => {
                    return values.indexOf(item.key) === -1
                })
                // 至少保留一个标签页
                /* if (tabs.length === 0) {
                     tabs = [state.tabs[0]]
                 }*/
                // 若删除的包含当前页则跳转其他页
            if (tabs.every(item => item.value !== state.active)) {
                const tab = tabs[tabs.length - 1]
                if (tab) {
                    tab.visible = true
                    commit('SET_ACTIVE', tab.key)
                    commit('SET_ACTIVE_TAB', tab)
                }
            }
            // 设置当前未删除的标签页
            commit('SET_TABS', tabs)
        },
        /**
         * 清除标签页
         * @param {*}
         */
        clear({ commit }) {
            commit('SET_ACTIVE', '')
            commit('SET_TABS', [])
        },
        addTabs({ commit }, tab) {
            commit('ADD_TABS', tab)
        },
        setTabs({ commit }, tabs) {
            commit('SET_TABS', tabs)
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/tabs/index.js